/**
 * ヘッダーの処理
 */

export default class Header {
  constructor() {
    this.header = document.querySelector('#js-header');
    if (!this.header) return;
    this.scrolledPastThreshold = false;
    this.init();
  }

  // /**
  //  * 2つの監視要素を設定してヘッダースタイルを制御
  //  */
  // setupObservers() {
  //   const topTriggerId = 'js-header-top-trigger';
  //   const scrollTriggerId = 'js-header-scroll-trigger';

  //   // 監視要素を生成
  //   document.body.insertAdjacentHTML('afterbegin', `<div id="${topTriggerId}"></div>`);
  //   document.body.insertAdjacentHTML('beforeend', `<div id="${scrollTriggerId}"></div>`);

  //   // 監視要素のスタイルを設定
  //   const topTrigger = document.getElementById(topTriggerId);
  //   const scrollTrigger = document.getElementById(scrollTriggerId);

  //   Object.assign(topTrigger.style, {
  //     position: 'absolute',
  //     top: '0px',
  //     height: '1px',
  //     width: '100%',
  //     pointerEvents: 'none',
  //   });

  //   Object.assign(scrollTrigger.style, {
  //     position: 'absolute',
  //     top: '1200px', // 800px地点に配置
  //     height: '1px',
  //     width: '100%',
  //     pointerEvents: 'none',
  //   });

  //   // Intersection Observerの設定
  //   const observerOptions = {
  //     threshold: 0,
  //     rootMargin: '0px'
  //   };

  //   const topObserver = new IntersectionObserver(this.handleTopIntersection.bind(this), observerOptions);
  //   const scrollObserver = new IntersectionObserver(this.handleScrollIntersection.bind(this), observerOptions);

  //   topObserver.observe(topTrigger);
  //   scrollObserver.observe(scrollTrigger);
  // }

  // /**
  //  * トップ監視要素のIntersection Observer コールバック
  //  */
  // handleTopIntersection(entries) {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting && this.scrolledPastThreshold) {
  //       // 800px未満にスクロールバックした場合
  //       this.scrolledPastThreshold = false;
  //       this.updateHeaderStyle(false);
  //     }
  //   });
  // }

  // /**
  //  * スクロール監視要素のIntersection Observer コールバック
  //  */
  // handleScrollIntersection(entries) {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting && !this.scrolledPastThreshold) {
  //       // 初めて800px以上スクロールした場合
  //       this.scrolledPastThreshold = true;
  //       this.updateHeaderStyle(true);
  //     }
  //   });
  // }

  // /**
  //  * ヘッダースタイルを更新
  //  */
  // updateHeaderStyle(scrolled) {
  //   document.body.setAttribute('data-header-scrolled', String(scrolled));
  // }

  // init() {
  //   this.setupObservers();
  // }

  init() {
    // スクロールイベントをデバウンスする関数
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // スクロール位置を確認し、必要に応じてclassを追加/削除する関数
    function checkScroll() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      console.log(scrollPosition)
      if (scrollPosition > 600) {
        document.body.setAttribute('data-header-scrolled', 'true');
      } else {
        document.body.setAttribute('data-header-scrolled', 'false');
      }
    }

    // デバウンスされたcheckScroll関数
    const debouncedCheckScroll = debounce(checkScroll, 30);

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', debouncedCheckScroll);

    // ページ読み込み時に初期状態をチェック
    document.addEventListener('DOMContentLoaded', checkScroll);
  }
}